import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "title-2" }, "Un email vous a été envoyé", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Un email avec un lien pour votre mot de passe vous a été envoyé.", -1)

import { request } from "@/domains/api/api";
import { FormErrors, FormParams } from "@/domains/app/forms";
import Form from "@/domains/app/components/Form.vue";
import { ref } from "vue";
import { useFlashes } from "@/domains/flashes/flashes";
import { useRoute, useRouter } from "vue-router";
import Modal from "@/domains/app/components/Modal.vue";
import { useLoading } from "@/domains/app/loading";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const email = ref("");
const submitted = ref(false);
const errors = ref<FormErrors | null>(null);
let secret: string;

const router = useRouter();
const route = useRoute();
if (route.query.email) {
    const p_secret = Array.isArray(route.query.secret)
        ? route.query.secret[0]
        : route.query.secret;
    if (p_secret) {
        secret = decodeURIComponent(p_secret);
    }

    const forced = Array.isArray(route.query.email)
        ? route.query.email[0]
        : route.query.email;
    if (forced) {
        email.value = forced;
        submit();
    }
}

function submit() {
    const e = email.value;
    const { setLoading } = useLoading("reset-password-get-token");
    setLoading(true);
    return request<{ status: "success"; token?: string }>(
        "reset-password/email",
        "post",
        (err) => (errors.value = err),
        { email: e, secret }
    ).then((rs) => {
        submitted.value = true;
        if (rs?.token) {
            router
                .push({
                    name: "auth.reset-password",
                    query: {
                        token: rs?.token,
                        email: e,
                    },
                })
                .then(() => {
                    setLoading(false);
                });
        } else {
            useFlashes().addFlash("Un email vous a été envoyé", "success");
            setLoading(false);
        }
    });
}

const formParams: FormParams = {
    showSubmitedFlash: false,
    driver: {
        submit,
    },
    fields: [
        {
            type: "text",
            getState: () => email,
            label: "Email",
            name: "email",
        },
    ],
    title: "Demande de modification de mot de passe",
    getErrors: () => errors,
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Form, _normalizeProps(_guardReactiveProps(formParams)), null, 16),
    (submitted.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          onConfirm: _cache[0] || (_cache[0] = ($event: any) => (submitted.value = false)),
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (submitted.value = false)),
          onExit: _cache[2] || (_cache[2] = ($event: any) => (submitted.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})